import { Component, Input } from '@angular/core';
import { ClassicPreset } from 'rete';
import { ReteModule } from 'rete-angular-plugin/21';

@Component({
  selector: 'app-magnetic-connection',
  template: `
    <svg data-testid="connection" class="magnetic-connection">
      <path [attr.d]="path" />
    </svg>
  `,
  styleUrls: ['./magnetic-connection.component.scss'],
  imports: [ReteModule],
})
export class MagneticConnectionComponent {
  @Input()
  public data!: ClassicPreset.Connection<ClassicPreset.Node, ClassicPreset.Node>;

  @Input()
  public start: unknown;

  @Input()
  public end: unknown;

  @Input()
  public path: string;
}
